import type { MailSnoozeEntry } from "@/lib/snooze/constants";

export const MAIL_SNOOZE_WOKE_EVENT = "mailSnoozeWoke";

export type MailSnoozeWokeDetail = {
  accountId: number;
  entries: Array<Pick<MailSnoozeEntry, "folder" | "uid" | "subject" | "holdFolder">>;
};

export function notifySnoozeWoke(
  accountId: number,
  entries: MailSnoozeWokeDetail["entries"]
): void {
  if (accountId < 1 || entries.length === 0) return;
  window.dispatchEvent(
    new CustomEvent<MailSnoozeWokeDetail>(MAIL_SNOOZE_WOKE_EVENT, {
      detail: { accountId, entries },
    })
  );
}
